import React from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../shared/CustomButton";
import DateTimePickerWithTextField from "../shared/DateTimePicker";
import { Formik } from "formik";
import { initialFilters } from "../../utils/filters";
import FilterController from "../shared/filters/utils/FilterController";

const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  minHeight: 460,
  bgcolor: "#F8FAFB",
  boxShadow: 24,
  borderRadius: "5px",
  outline: "none",
  display: "flex",
  flexDirection: "column",
};

const NewReportModal = ({
  open,
  onClose,
  processing,
  discardChanges,
  saveChanges,
}) => {
  const [nameError, setNameError] = React.useState("");
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-un-saved-changes"
      aria-describedby="modal-un-saved-changes"
    >
      <Box sx={Modalstyle}>
        <Box
          sx={{
            bgcolor: "#050D2E",
            height: "25%",
            color: "#F8FAFB",
            px: 4,
            py: 2,
            mb: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopLeftRadius: "5px",
            borderTopRightRadius: "5px",
          }}
        >
          <Typography
            id="change-license"
            sx={{
              fontSize: "1.25rem",
              fontWeight: 550,
              lineHeight: "24px",
            }}
          >
            Add New Report
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={onClose} />
        </Box>

        <Formik
          initialValues={{
            dateTimeFrom: initialFilters.dateTimeFrom,
            dateTimeTo: initialFilters.dateTimeTo,
            reportName: "",
          }}
          enableReinitialize
        >
          {({ values, setValues }) => {
            return (
              <>
                <Box
                  sx={{
                    minWidth: 350,
                    padding: "1rem",
                  }}
                >
                  <FilterController label="Report Name" error={nameError}>
                    <TextField
                      name="reportName"
                      value={values.reportName}
                      size="small"
                      placeholder="Enter report name"
                      sx={{ background: "#fff" }}
                      error={!!nameError}
                      onChange={(e) => {
                        setValues({ ...values, reportName: e.target.value });
                        setNameError("");
                      }}
                    />
                  </FilterController>
                  <FilterController label="Date/Time range">
                    <DateTimePickerWithTextField
                      label=""
                      icon="calendar"
                      onChange={(value) => {
                        setValues({ ...values, ...value });
                      }}
                      showTooltip
                      dateTimeFrom={values.dateTimeFrom}
                      dateTimeTo={values.dateTimeTo}
                      type="ranges"
                      position="auto"
                    />
                  </FilterController>
                </Box>
                <Divider sx={{ marginTop: "auto" }} />

                <Grid
                  container
                  justifyContent="flex-end"
                  columnSpacing={2}
                  sx={{
                    pr: 4,
                    pl: 4,
                    py: 2,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <CustomButton
                    text="Cancel"
                    type="secondary"
                    processing={false}
                    action={discardChanges}
                  />
                  <div style={{ width: "10px" }}></div>
                  <CustomButton
                    text="Show Data"
                    type="update"
                    processing={processing}
                    action={() => {
                      if (!values.reportName) {
                        setNameError("Please enter report name");
                        return;
                      }
                      saveChanges(values);
                    }}
                  />
                </Grid>
              </>
            );
          }}
        </Formik>
      </Box>
    </Modal>
  );
};

export default NewReportModal;
